/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";
export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'single',
    profile: {

        p_name_col_name: 'Item',

        p_description_col_name: 'Desc do Item',
        p_date_1_col_name: 'Data Doc',

        s_col_name: 'Fornecedor',

        showSupplierIdInSupplierNormalization: true,

        showBusinessUnitInSupplierNormalization: true,

        showSupplierVatInSupplierNormalization: true,

        synergyDashboardShowBusinessUnits: true,
        advancedDashboardShowGeoRegionFilter: true,
        showSupplierIdInAdvDashboard: true,
        defaultSearchKeys: ['p_description', 'p_mat_group_description', 'p_mat_name'],
        additionalSearchKeys: [
            'part__p_mat_name',
            'part__p_mat_group_description',
        ],
        searchConfiguration: 'default_p_desc',
        categorizationReviewSubRowRelationData: [{
            relation: "part",
            columns: [
                {
                    db_column: "p_description",
                    colSpec: {cls: 'col-txt', txt: 'Desc do Item', columnFieldId: 'p_description', width: 145}
                },
                {
                    db_column: "p_mat_name",
                    colSpec: {cls: 'col-txt', txt: 'Carteira', columnFieldId: 'p_mat_name'}
                },
                {
                    db_column: "p_po_number",
                    colSpec: {cls: 'col-txt', txt: 'Nº Pedido de Compra', columnFieldId: 'p_po_number'}
                },
                {
                    db_column: "p_context_1",
                    colSpec: {cls: 'col-txt', txt: 'Contrato', columnFieldId: 'p_context_1'}
                },
                {
                    db_column: "p_mat_group_description",
                    colSpec: {cls: 'col-txt', txt: 'Categoria', columnFieldId: 'p_mat_group_description'}
                },
                {
                    db_column: "p_vat_number",
                    colSpec: {cls: 'col-txt', txt: 'CNPJ', columnFieldId: 'p_vat_number'}
                },
            ]
        }],

        locale: 'pt-br',
        currency: 'BRL',

        allowIncompleteTaxonomy: true,

        initialGroupBySupplierInactive: true, // Temporary for sample, needs to be reverted for full delivery (CAT-2838)

        ppvConfigEnabledColumns: [
            'part',
            'supplier',
            'business_unit', // Enabled for Compass
        ],

        supplierStandAloneFilter: '(default)', // See CAT-3590 before changing this
        disableSupplierNormalizationAiModel: true,
        disableCommonSuppliersAdvDashboard: true, // For compass these switches didn't do anything
        disableCommonCategoryAdvDashboard: true, // For compass these switches didn't do anything

        enableProcChat: true,
        enableGoldenRecord: true,
    },
}
